import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
// import configuration from '../config/global'
import * as contentful from 'contentful'
import * as contentfulManagement from 'contentful-management'

Vue.use(VueResource)
Vue.use(Vuex)

const config = process.env

const client = contentful.createClient({
  space: config.contentful_api.space,
  accessToken: config.contentful_api.access_token
})
const managerClient = contentfulManagement.createClient({
  // space: config.contentful_api.space,
  accessToken: config.contentful_api.pat
})

// root state object.
// each Vuex instance is just a single state tree.
const state = {
  socketConnected: false,
  appConfig: {},
  appData: {},
  pages: {},
  products: {},
  isthedarkness: true
}

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  SOCKET_CONNECT: (state, status) => {
    state.socketConnected = true
  },
  SOCKET_DISCONNECT: (state, status) => {
    state.socketConnected = false
  },
  setAppConfig: (state, data) => {
    state.appConfig = data.fields
  },
  setAppRootData: (state, data) => {
    state.appData.root = data
  },
  setAppData: (state, data) => {
    Vue.set(state.appData, 'global', data)
  },
  clearPages: (state, data) => {
    state.pages = {}
  },
  clearProducts: (state, data) => {
    state.products = {}
  },
  setPage: (state, data) => {
    // console.log('[Mutation] – setPage', state, data)
    Vue.set(state.pages, data.slug || data.name.toLowerCase(), data)
  },
  setProduct: (state, data) => {
    Vue.set(state.products, data.sys.id, data.fields)
  },
  switchStyle: (state, value) => {
    state.isthedarkness = value !== undefined ? value : !state.isthedarkness
  }
}

// actions are functions that causes side effects and can involve
// asynchronous operations.
const actions = {
  updateStyle: ({commit}, value) => {
    value !== undefined ? commit('switchStyle', value) : commit('switchStyle')
  },
  socket_event: ({commit}, data) => {
    // Streamlabs generic socket event, type is in object
    // TODO: get config info from streamlabs as well, like getting active notification types
    let parsedData = {}
    // let msg = data.message[0]

    switch (data.type) {
      case 'loremipsum':
        parsedData = {type: null}
        break
      default:
        parsedData = {type: null}
    }

    parsedData.type != null ? commit('registerAlert', parsedData) : console.warn('[Message type not recognised] Received type: ' + data.type)
  },
  updateAppConfig: function ({commit}, data) {
    data != null ? commit('setAppConfig', data) : console.error('[setAppConfig] No data received')
  },
  updateAppRootData: function ({commit}, data) {
    // this.dispatch('updateAppConfig', data.items[0].fields.configuration)
    data != null ? commit('setAppRootData', data) : console.error('[setAppRootData] No data received')
  },
  updateAppData: function ({commit}, data) {
    data != null ? setTimeout(() => { commit('setAppData', data) }, 200) : console.error('[setAppData] No data received')
  },
  updateProductsData: function ({commit}, data) {
    if (data.items.length > 0) {
      data.items.forEach((n, i) => {
        commit('setProduct', n)
      })
    }
    // parsedData != null ? setTimeout(() => { commit('setProduct', parsedData) }, 200) : console.error('[setProductsData] No data received')
  },
  updatePageData: function ({commit}, data) {
    // console.log('[Action] – updatePageData')
    // FIXME: clearing pages and then updating pages on every loop iteration causes the page watcher in pagebase to see an empty object
    // commit('clearPages')
    if (data.items[0] && data.items[0].fields.pages) {
      // console.log('data items -> pages', data.items[0].fields.pages)
      data.items[0].fields.pages.forEach((n, i) => {
        // console.log('forEach', i, n)
        commit('setPage', n.fields)
      })
    }
  },
  getContentTypes: function (context) {
    // TODO: update these functions to use the contentful client
    return Vue.http.get(
      config.contentful_api.content_types,
      {
        params: {
          access_token: config.contentful_api.access_token
        }
      }
    ).then(function (response) {
      // Parse response as JSON
      return response.json()
    })
  },
  getEntries: function (context, data) { // data = content_type
    return Vue.http.get(
      config.contentful_api.entries,
      {
        params: {
          access_token: config.contentful_api.access_token,
          content_type: data
        }
      }
    ).then(function (response) {
      // Parse response as JSON
      return response.json()
    })
  },
  getEntry: function (context, data) { // data = entry_id
    return Vue.http.get(
      config.contentful_api.entries + data,
      {
        params: {
          access_token: config.contentful_api.access_token
        }
      }
    ).then(function (response) {
      // Parse response as JSON
      return response.json()
    })
  },
  getContentType: function (context, data) {
    client.getEntries({
      content_type: data.contentType,
      'fields.type': data.type,
      include: 10
    }).then((d) => {
      this.dispatch('updateProductsData', d)
    })
  },
  getLinkedEntries: function (context, data) { // data = entry_id
    // console.log('[Action] – getLinkedEntries')
    let result = null

    client.getEntries({
      'sys.id': data.id,
      include: 10
    }).then((d) => {
      switch (data.update) {
        case 'app':
          this.dispatch('updateAppData', d)
          this.dispatch('updateAppConfig', d.items[0].fields.configuration)
          this.dispatch('updatePageData', d)
          break
        case 'products':
          this.dispatch('updateProductsData', d)
          break
        case 'product':
          result = d
          break
      }
      return result
    })
    // return Vue.http.get(
    //   config.contentful_api.entries,
    //   {
    //     params: {
    //       access_token: config.contentful_api.access_token,
    //       include: config.contentful_api.limit,
    //       content_type: 'website',
    //       'fields.pages.sys.id': data.fieldId
    //     }
    //   }
    // ).then(function (response) {
    //   // Parse response as JSON
    //   return response.json()
    // })
  },
  getAsset: function (context, data) { // data = asset_id
    return Vue.http.get(
      config.contentful_api.assets + data,
      {
        params: {
          access_token: config.contentful_api.access_token
        }
      }
    ).then(function (response) {
      // Parse response as JSON
      return response.json()
    })
  },
  saveAnswers: function (context, data) {
    managerClient.getSpace(config.contentful_api.space).then(space => space.getEnvironment('master')
      .then((environment) => {
        environment.createEntry('session', {
          fields: {...data}
        }).then((entry) => {
          // save new entry as link in corresponding conversation
          console.log('entry created =>', entry)
          environment.getEntry(data.conversationId['en-US']).then((conv) => {
            console.log('conversation =>', conv)
            conv.fields.sessions
              ? conv.fields.sessions['en-US'].push({sys: {type: 'Link', linkType: 'Entry', id: entry.sys.id}})
              : conv.fields.sessions = {'en-US': [{sys: {type: 'Link', linkType: 'Entry', id: entry.sys.id}}]}
            return conv.update()
          }).then((entry) => console.log('entry updated', entry)).catch(console.error)
        }).catch(console.error)
      })
    )
  }
}
// getters are functions
const getters = {
  domain: state => config.contentful_api.domain_entry_id,
  appConfig: state => state.appConfig,
  appData: state => state.appData,
  pages: state => state.pages,
  products: state => state.products,
  isthedarkness: state => state.isthedarkness
}

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js